export function checkoutConfirmationController(formElement) {
    // TODO
}
